import type { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

export function firstOf (query: ReturnType<typeof useQuery>) {
  return {
    ...query,
    data: computed(() => query.data.value[0])
  }
}
